import { Box, Icon, Text } from '@bonanza-social/moonlight';
import { memo } from 'react';
import { Pressable } from 'react-native';
import { UnderMaintenanceProps } from './UnderMaintenance.types';

function UnderMaintenance({ onPress }: UnderMaintenanceProps) {
  return (
    <Box position="absolute" width="100%" height="100%">
      <Pressable onPress={onPress} style={{ flex: 1 }}>
        <Box
          backgroundColor="blackBackground"
          opacity={0.5}
          width="100%"
          height="100%"
          zIndex={1}
        />
        <Box
          zIndex={2}
          position="absolute"
          alignSelf="center"
          bottom="space-100"
          backgroundColor="primaryBackground"
          borderRadius="radius-400"
          flexDirection="row-reverse"
          alignItems="center"
          justifyContent="center"
          gap="space-100"
          paddingHorizontal="space-0"
          width="95%"
          maxWidth={100}
          maxHeight="space-600"
          overflow="hidden"
          flexWrap="wrap-reverse"
        >
          <Box flexDirection="row" alignItems="center" height="space-600">
            <Text
              variant="badge"
              locNS="common"
              locKey="maintenance"
              gradient="darkSurfaceAccent"
              numberOfLines={1}
            />
          </Box>
          <Icon name="maintenance" width="space-400" height="space-400" />
        </Box>
      </Pressable>
    </Box>
  );
}
export default memo(UnderMaintenance);
